import React from "react";
import { appendEllipsis } from "../../../utils/helper";

const CardDescription = ({ post }) => {
  return (
    <div
      className="text-base font-normal mb-2"
      dangerouslySetInnerHTML={{ __html: post.description && appendEllipsis(post.description) }}
    ></div>
  );
};

export default CardDescription;
